import { Tooltip } from '@crehana/compass.ui';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var PlayroomRewardIndicatorTooltip = function PlayroomRewardIndicatorTooltip(_ref) {
  var tooltip = _ref.tooltip,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'top' : _ref$position,
    children = _ref.children;
  if (tooltip) {
    return /*#__PURE__*/_jsx(Tooltip, {
      type: "small",
      label: tooltip,
      position: position,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default PlayroomRewardIndicatorTooltip;